<template>
  <b-overlay :show="!sample">
    <b-card>
      <b-row class="mb-3">
        <b-col cols="8">
          <div v-if="customer" class="h5 font-weight-bold">
            {{ customer.full_name }}
          </div>
          <div style="font-size: 0.7rem;">
            <div>
              Project #: {{ sample_project.publicNumber() }}
            </div>
            <div>Submission #: {{ sample_submission.publicNumber() }}</div>
            <div>Sample #: {{ sample.publicNumber() }}</div>
            <div>Identifier: {{ sample.identifier }}</div>
          </div>
        </b-col>
        <b-col cols="4">
          <img src="img/brand/logo.png" style="width: 100%" />
        </b-col>
      </b-row>
      <barcode
        :value="sample.publicNumber()"
        width="2"
        height="50"
        class="text-center"
      >
        Barcode rendering failed.
      </barcode>
      <div v-if="receive" class="print-hidden">
        <b-button v-if="sample.receiving_id" block disabled>
          Received - {{ sample.receiving_id }}
        </b-button>
        <b-button
          v-else
          block
          variant="success"
          @click="$emit('receiveSample', sample)"
        >
          Receive
        </b-button>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import CustomerModel from "@/models/crm/CustomerModel";
import SampleModel from "@/models/lab/SampleModel";
import VueBarcode from "vue-barcode";

export default {
  name: "SampleReceivingLabel",
  components: {
    barcode: VueBarcode
  },
  props: {
    customer: {
      type: CustomerModel,
      default: () => null
    },
    sample: {
      type: SampleModel,
      default: () => null
    },
    submission: {
      type: Object,
      default: () => null
    },
    receive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sample_submission() {
      return this.submission || this.sample.getSubmission();
    },
    sample_project() {
      return this.sample_submission.getProject()
    }
  }
};
</script>
